var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`features-ecommerce-item-1`, _vm.className || ``]},[_c('p',{staticClass:"duis-aute-irure-dolo-13 inter-normal-gull-gray-18px"},[_vm._v(_vm._s(_vm.duisAuteIrureDolo))]),_c('img',{staticClass:"icon-check_mark-2",attrs:{"src":_vm.iconCheck_Mark,"alt":"icon-check_mark"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }